webpackJsonp([23899280101116],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExperienceBox = function ExperienceBox(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'experience box' },
	    _react2.default.createElement(
	      'div',
	      { className: 'logo-container', style: { background: props.color } },
	      _react2.default.createElement('img', { src: ("") + '/logos/' + props.logo }),
	      _react2.default.createElement(
	        'h4',
	        null,
	        props.role
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-container' },
	      _react2.default.createElement(
	        'p',
	        null,
	        props.shortDescription
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        props.tags.map(function (tag) {
	          return _react2.default.createElement(
	            'li',
	            { key: tag },
	            tag
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = ExperienceBox;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _experienceBox = __webpack_require__(207);
	
	var _experienceBox2 = _interopRequireDefault(_experienceBox);
	
	var _cta = __webpack_require__(41);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkPage = function WorkPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Work'
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'work', className: 'container' },
	      data.allExperienceYaml.edges.map(function (_ref2, index) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_experienceBox2.default, {
	          key: index,
	          name: node.name,
	          role: node.role,
	          logo: node.logo,
	          tags: node.tags,
	          color: node.color,
	          shortDescription: node.shortDescription
	        });
	      })
	    ),
	    _react2.default.createElement(_cta2.default, { primary: { to: '/thoughts', text: 'Read Thoughts' }, scrollToTop: true })
	  );
	};
	
	exports.default = WorkPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-js-d904a8fb9e3aa1ea40a4.js